<template lang="pug">
.box-item-answer
  .sequence(v-if="type === 1")
    .box-answer-input
      .value {{value}}
      .item-checkbox
        input(type="checkbox" 
          :name="'answer' + qd_index"
          :value="id"
          :checked="isChecked"
          :id="'answer' + qd_index + '_' + id + value"  
          @click="onClickChecked($event)")
        label(:for="'answer' + qd_index + '_' + id + value")
    .material-icons(@click="deleteAnswer") delete
  .clearfix(v-if="$isMobile()")
  .froala(:style="type === 2 ? 'width: 100%;' : 'width: calc(100% - 60px);'")
    froala(:tag="'textarea'" :config="configFroala" v-model="lastContent" v-on:input="changeAnswer($event)")
    input.hide(:id="'froala_answer' + qd_index + '_' + id + value")
  
</template>

<script>
// import jQuery from 'jquery'
export default {
  props: {
    id: Number,
    value: String,
    qd_index: Number,
    iAnswer: Number,
    isChecked: Boolean,
    type: Number,
    content: String
  },
  data() {
    return {
      configFroala: {
        fullPage: true,
        placeholderText: 'Nhập ...',
        charCounterCount: true,
        key: 'jUA1yD5B4D1C1F2D1pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2B1B10B2A3E6D1G2==',
        iframe: true,
        immediateVueModelUpdate: true,
        charCounterMax: 14000,
        // width: '1200',
        // useClasses: false,
        events: {
          'froalaEditor.initialized': function () {
            console.log('initialized')
          }
        }
      },
      checked: this.isChecked,
      lastContent: this.content
    }
  },
  methods: {
    changeAnswer (content) {
      // console.log('content: ', content)
      var data = {
        checked: this.checked,
        id: this.id,
        content: content,
        value: this.value
      }
      this.$emit('onCheckedAnswer', data)
    },
    onClickChecked(e) {
      // console.log(this.qd_index + this.value + ' is: ', e.target.checked)
      this.checked = e.target.checked
      var data = {
        checked: this.checked,
        id: this.id,
        content: this.lastContent,
        value: this.value
      }
      this.$emit('onCheckedAnswer', data)
    },
    deleteAnswer(e) {
      // console.log('deleteAnswer: ', this.checked)
      var data = {
        checked: this.checked,
        iAnswer: this.iAnswer
      }
      this.$emit('onDeleteAnswer', data)
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.box-item-answer {
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  .sequence {
    width: 50px;
    text-align: center;
    margin-right: 10px;
    .box-answer-input {
      margin-bottom: 16px;
      .value {
        padding: 7px 0;
        background: #fff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        font-size: 14px;
        font-weight: bold;
        justify-content: center;
        align-items: center;
        box-shadow: 1px -1px 2px #00000029;
      }
      .item-checkbox{
        display:inline-flex; 
        width: 50px;
        justify-content: center;
        align-items: center; 
        padding: 7px 0; 
        background: #fff; 
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px; 
        border-top: 1px solid #FBF4D2;
        box-shadow: 1px 1px 2px #00000029;
        input{display:none;}
        input + label{cursor: pointer;background: url("../../../assets/images/faces/ic_check_box_OFF@2x.png") no-repeat center center;height: 24px;width: 24px;display:inline-block; background-size: cover; margin: 0;}
        input:checked + label{cursor: pointer;background: url("../../../assets/images/faces/ic_check_box_ON@2x.png") no-repeat center center;height: 24px;width: 24px;display:inline-block;background-size: cover;}
      }
    }
    .material-icons {cursor: pointer;}
  }
  .froala {width: calc(100% - 60px);}
}
@media (max-width: 414px) {
  .box-item-answer {
    display: inline-block;
    .sequence {
      width: 100%;
      .box-answer-input {
        display: inline-flex;
        float: left;
        margin-bottom: 8px;
        .value {width: 50px; height: 32px; font-size: 16px; border-top-right-radius: 0px; border-bottom-left-radius: 10px; box-shadow: 1px 1px 2px #00000029;}
        .item-checkbox {border-bottom-left-radius: 0px; border-top-right-radius: 10px; box-shadow: 1px 1px 2px #00000029; border-top: none; height: 32px;}
      }
      .material-icons {float: right;}
    }
    .froala {width: 100% !important;}
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?27d20e96